import { useCallback, useEffect } from "preact/hooks";
import useAxios from "../../hooks/useAxios";


export default function useOverview() {

    const { data: overviewInfo, fetch } = useAxios();

    const fetchOverviewInfo = useCallback((config) => {
        const targetUrl = `/user/reports/overview`;
        const requestParams = { method: "GET", ...config };
        return fetch(targetUrl, requestParams);
    }, []);

    useEffect(() => fetch(`/user/reports/overview`, {
        method: "GET",
        params: {
            date_from: parseInt(new Date(
                new Date().getFullYear(),
                new Date().getMonth(), 1).getTime() / 1000
            ),
            date_to: parseInt(new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1, 0, 23, 59, 59).getTime() / 1000
            )
        }
    }), []);

    return { overviewInfo, fetchOverviewInfo };
}